import {
    BULK_ROUTES,
    CREATE_WORK_ROUTE,
    EDIT_ROUTE,
    FORM_ROUTE,
    MANUAL_ROUTE,
    RIGHTSHOLDER_ROUTE,
    STEP_ROUTES,
    WIZARD_ROUTE,
} from '@App/navigation/route'
import { ID } from '@App/navigation/index'

export const createRootRightsholderRoute = (id: ID): string => `/${RIGHTSHOLDER_ROUTE}/${id}`
export const createRootWizardRoute = (id: ID): string =>
    `${createRootRightsholderRoute(id)}/${CREATE_WORK_ROUTE}/${WIZARD_ROUTE}`
export const createRootFormRoute = (id: ID): string =>
    `${createRootRightsholderRoute(id)}/${CREATE_WORK_ROUTE}/${FORM_ROUTE}`
export const createRootBulkRoute = (id: ID): string =>
    `${createRootRightsholderRoute(id)}/${CREATE_WORK_ROUTE}/${BULK_ROUTES.root}`
export const createRootBulkEditRoute = (id: ID): string => `${createRootBulkRoute(id)}/${EDIT_ROUTE}`

export const createWorkNavigation = (id: ID) => ({
    root: `/${RIGHTSHOLDER_ROUTE}/${id}/${CREATE_WORK_ROUTE}/${MANUAL_ROUTE}`,
    wizard: {
        root: createRootWizardRoute(id),
        workDetails: `${createRootWizardRoute(id)}/${STEP_ROUTES.workDetails}`,
        writers: `${createRootWizardRoute(id)}/${STEP_ROUTES.writers}`,
        publishers: `${createRootWizardRoute(id)}/${STEP_ROUTES.publishers}`,
        publishersShares: `${createRootWizardRoute(id)}/${STEP_ROUTES.publishersShares}`,
        publishersWriters: `${createRootWizardRoute(id)}/${STEP_ROUTES.publishersWriters}`,
        review: `${createRootWizardRoute(id)}/${STEP_ROUTES.review}`,
        recordings: `${createRootWizardRoute(id)}/${STEP_ROUTES.recordings}`,
        submission: `${createRootWizardRoute(id)}/${STEP_ROUTES.submission}`,
    },
    form: {
        root: createRootFormRoute(id),
        workDetails: `${createRootFormRoute(id)}/${STEP_ROUTES.workDetails}`,
        writers: `${createRootFormRoute(id)}/${STEP_ROUTES.writers}`,
        writersSharesRole: `${createRootFormRoute(id)}/${STEP_ROUTES.writersShares}`,
        publishers: `${createRootFormRoute(id)}/${STEP_ROUTES.publishers}`,
        publishersShares: `${createRootFormRoute(id)}/${STEP_ROUTES.publishersShares}`,
        publishersWriters: `${createRootFormRoute(id)}/${STEP_ROUTES.publishersWriters}`,
        recordings: `${createRootFormRoute(id)}/${STEP_ROUTES.recordings}`,
        submission: `${createRootFormRoute(id)}/${STEP_ROUTES.submission}`,
    },
    bulk: {
        root: createRootBulkRoute(id),
        fileUpload: `${createRootBulkRoute(id)}/${BULK_ROUTES.fileUpload}`,
        fileReview: `${createRootBulkRoute(id)}/${BULK_ROUTES.fileReview}`,
        submission: `${createRootBulkRoute(id)}/${BULK_ROUTES.submission}`,
        edit: {
            root: createRootBulkEditRoute(id),
            workDetails: `${createRootBulkEditRoute(id)}/${STEP_ROUTES.workDetails}`,
            writers: `${createRootBulkEditRoute(id)}/${STEP_ROUTES.writers}`,
            writersSharesRole: `${createRootBulkEditRoute(id)}/${STEP_ROUTES.writersShares}`,
            publishers: `${createRootBulkEditRoute(id)}/${STEP_ROUTES.publishers}`,
            publishersShares: `${createRootBulkEditRoute(id)}/${STEP_ROUTES.publishersShares}`,
            publishersWriters: `${createRootBulkEditRoute(id)}/${STEP_ROUTES.publishersWriters}`,
            recordings: `${createRootBulkEditRoute(id)}/${STEP_ROUTES.recordings}`,
            submission: `${createRootBulkEditRoute(id)}/${STEP_ROUTES.submission}`,
        },
    },
})
